import { createReducer, on } from '@ngrx/store';
import * as PlantListUserGuidActions from './plant-list-userguid.actions';
import { PlantListUserGuidState } from './plant-list-userguid.models';

export const initialState: PlantListUserGuidState = {
  plants: undefined,
  loading: false,
  error: null,
  currentKey: null,
};

export const plantListUserGuidReducer = createReducer(
  initialState,
  on(PlantListUserGuidActions.loadPlantListUserGuid, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(PlantListUserGuidActions.loadPlantListUserGuidSuccess, (state, { key, plants }) => ({
    ...state,
    loading: false,
    error: null,
    plants: { [key]: plants },
    currentKey: key,
  })),
  on(PlantListUserGuidActions.loadPlantListUserGuidFailure, (state, { error, key }) => ({
    ...state,
    loading: false,
    error,
    plants: { [key]: [] },
  })),
  on(PlantListUserGuidActions.resetPlantListUserGuid, () => initialState),
);
